<script setup lang="ts">
import type { CallToAction } from '~~/types/navigation'

defineProps<{ promo: CallToAction, closeMenu: () => void }>()
</script>

<template>
  <div
    class="mega-card"
    :class="[{ 'mega-card--light-aqua': promo.backgroundColor === 'aqua' }]"
  >
    <div v-if="promo.variant !== 'subscription'">
      <NuxtImg
        provider="fastlyAprimo"
        :src="promo.image?.imageUrl"
        :alt="promo.image?.imageAltText"
        class="mega-card__image"
        loading="lazy"
        :width="promo.image?.width ?? 466"
      />
      <div class="mega-card__body">
        <p class="mega-card__heading">
          {{ promo.title }}
        </p>
        <p
          v-if="!promo.linkSubtitle?.url"
          class="mega-card__sub-head"
        >
          {{ promo.subtitle }}
        </p>
        <p
          v-if="promo.linkSubtitle?.url"
          class="mega-card__sub-head"
        >
          <ULink
            class="underline"
            :to="useCmsUrl(promo.linkSubtitle.url)"
            :locale="false"
            @click="closeMenu()"
          >
            {{ promo.linkSubtitle?.title }}
          </ULink>
        </p>
        <p>{{ promo.description }}</p>
        <p>
          <UButton
            color="primary"
            variant="solid"
            size="lg"
            :to="useCmsUrl(promo.linkButton?.url)"
            :locale="false"
            :label="promo.linkButton?.title"
            @click="closeMenu()"
          />
        </p>
      </div>
    </div>
    <div v-if="promo.variant === 'subscription'">
      <LazyBlockSubscriptionBlock
        :promo="promo"
        :close-menu="closeMenu"
      />
    </div>
  </div>
</template>
